export interface NotificareDoNotDisturb {
  readonly start: string;
  readonly end: string;
}
